import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const ShipmentsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 48 48"
  >
    <path
      fill="#8bc34a"
      d="M43 36H29V14h10.6c.9 0 1.6.6 1.9 1.4L45 26v8c0 1.1-.9 2-2 2"
    ></path>
    <path
      fill="#388e3c"
      d="M29 36H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h22c1.1 0 2 .9 2 2z"
    ></path>
    <g fill="#37474f">
      <circle cx={37} cy={36} r={5}></circle>
      <circle cx={13} cy={36} r={5}></circle>
    </g>
    <g fill="#78909c">
      <circle cx={37} cy={36} r={2}></circle>
      <circle cx={13} cy={36} r={2}></circle>
    </g>
    <path
      fill="#37474f"
      d="M41 25h-7c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h5.3c.4 0 .8.3.9.7l1.7 5.2c0 .1.1.2.1.3V24c0 .6-.4 1-1 1"
    ></path>
    <path
      fill="#dcedc8"
      d="m21.8 13.8l-7.9 7.9l-3.7-3.8L8 20.1l5.9 5.9L24 15.9z"
    ></path>
  </svg>
);
const ShipmentsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ShipmentsSvg} {...props} />
);
export default ShipmentsIcon;
